module.exports = __webpack_public_path__ + "static/media/photo.21918668.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/AboutSection/photo.jpg
// module id = 216
// module chunks = 0